import { IThunkActionCreator } from '.';
import { EAlertType } from '../types/microfrontends';

export { EAlertType };

export interface IRequestAuthenticationParams {
  alert?: EAlertType | null;
}

/**
 * Открывает модалку авторизации через API рантайма шапки.
 * `anchorHash` сохраняется в истории, чтобы после перезагрузки страницы вернуть пользователя к нужному блоку.
 */
export function requestAuthentication(
  anchorHash?: string,
  { alert = null }: IRequestAuthenticationParams = {},
): IThunkActionCreator {
  return (_dispatch, _getState, context) => {
    const { microfrontendsAPI } = context;

    if (!microfrontendsAPI) {
      return;
    }

    /*
      Якорь нужен после перезагрузки страницы, которую делает шапка при autoRefresh:
      по нему review_form, reviews_list и answers_list скроллят к нужному месту.
    */
    if (anchorHash) {
      const url = new URL(`#${anchorHash}`, window.location.href).toString();

      window.history.pushState({}, window.document.title, url);
    }

    void microfrontendsAPI.header.openAuthModal({
      autoRefresh: true,
      alert,
      useDefaultView: false,
      viewData: null,
      source: null,
    });
  };
}
